import React, { useEffect, useState } from "react";
import Element_top_service from "../../../components/topelementservice/Element_top_service";
import LoanService from "../../loanservice/LoanService";
// import ThemeMenu from '../../../components/thememenu/ThemeMenu';
import CardService from "../../../components/cardservice/CardService";
import axios from "axios";
import "./More.scss";
import SlideNew from "../../../components/slidernew/SlideNew";
import usePaginations from "../../../Paginations";
import { Pagination } from "@mui/material";
import Contant from "../../../Contant";

const PlaneTicket = (props) => {
  const [datas, setDatas] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios({
        method: "get",
        url: Contant + "api/posts?type=products",
        Headers: {
          Accept: "application.json",
          "Content-Type": "application/json",
        },
      });

      if (response.data.products.more === undefined) {
        setDatas(datas);
      } else {
        setDatas(response.data.products.more);
      }
    };
    fetchData();
  }, [props]);

  let [page, setPage] = useState(1);
  const PER_PAGE = 6;

  const count = Math.ceil(datas.length / PER_PAGE);
  var _DATA = usePaginations(datas, PER_PAGE);

  // console.log(_DATA)

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <div className="Main_style_serviceTop_element_more">
      <div className="style_frame_main_cards_service">
        <div className="frame_service_items">
          {_DATA.currentDatas().map((item, index) => (
            <div key={index}>
              <CardService
                Title={item.title}
                image={
                  "https://tiendungfinance.com.vn/api/data/images/" +
                  item.coverPhoto
                }
                date={item.date}
                id={item.id}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="frame_piantion">
        <Pagination
          count={count}
          size="small"
          page={page}
          variant="outlined"
          shape="rounded"
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default PlaneTicket;
